import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { visuallyHidden } from "@mui/utils";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import ConfirmBox from "../../UiComponents/ConfirmBox/ConfirmBox";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import { ToastError } from "../../UiComponents/Toaster/Toast";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {
  RemoveRedEyeIcon,
  SearchIcon,
  EditIcon,
  DownloadIcon,
  CloudOffIcon,
  RestartAltIcon,
} from "../../Resources/Icons/icons";
import moment from "moment";
// import ManageWallet from "./ManageWallet";
import filterr from "../../Resources/Images/filter-lines.png";
import exportt from "../../Resources/Images/export.png";
import {
  GetBranchWallet,
  ReframeEndDateTimeFormat,
} from "../../Service/_index";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import CommonPayableDrawer from "../CommonPayableDrawer/CommonPayableDrawer";
import { PolicyFilterTypes } from "../../Shared/CommonConstant";
import Loader from "../../UiComponents/Loader/Loader";
import { DatePicker, Radio } from "antd";
import { CSVLink } from "react-csv";
import { useEffect } from "react";
import ManageBranchWallet from "./ManageBranchWallet";
import MasterCommonTable from "../../UiComponents/CommonTable/MasterCommonTable";
import { Divider, Stack, Badge } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterBox from "../../UiComponents/FilterBox/FilterBox";
import CustomButton from "../../UiComponents/CommonBUtton/ConfirmBox";
const { RangePicker } = DatePicker;

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: "branchManager",
    placeMent: true,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "branch",
    placeMent: true,
    disablePadding: false,
    label: "Branch",
  },
  {
    id: "branchPayable",
    placeMent: true,
    disablePadding: false,
    label: "Branch Payable",
  },
  {
    id: "commisionPayable",
    placeMent: true,
    disablePadding: false,
    label: "Commision Payable",
  },
  {
    id: "pendingBalance",
    placeMent: true,
    disablePadding: false,
    label: "Pending Payable",
  },
  { id: "action", placeMent: false, disablePadding: false, label: "Action" },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const BranchWallet = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [wallet, setWallet] = React.useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [resetValue, setResetValue] = useState(1);
  const [selectedItems, setSelectedItems] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [tableConfig, setTableConfig] = useState({
    isSearch: true,
    isApprove: true,
    isMultiDelete: false,
    type: "branchWallet",
  });
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [showFilter, setShowFilter] = useState(false);

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(wallet), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, wallet]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - wallet.length) : 0;

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el?.branchManager},${el?.branch},${el?.branchPayable},${el?.commisionPayable},${el?.pendingBalance}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
    setPage(0);
  };

  const [endDate, setEndDate] = useState(null);
  const GetData = async (startDate, endDate) => {
    setOpenLoader(true);
    const sDate = startDate !== undefined ? startDate : selectedStartDate;
    const eDateRaw = endDate !== undefined ? endDate : selectedEndDate;
    let eDateFormatted = null;

    if (eDateRaw) {
      eDateFormatted = await ReframeEndDateTimeFormat(eDateRaw);
      setEndDate(eDateFormatted);
    }
    GetBranchWallet({ startDate: sDate, endDate: eDateFormatted })
      .then((res) => {
        setOpenLoader(false);
        const FilteredData = res?.data
          ?.map((row) => ({
            ...row,
            action: (
              <Button onClick={() => StateMentFunction(row)}>Statement</Button>
            ),
          }));
        // console.log(FilteredData);
        setWallet(FilteredData);
        setPage(0);
      })
      .catch((err) => {
        setOpenLoader(false);
        console.log("err");
      });
  };

  const header = [
    { label: "Branch Manager", key: "branchManager" },
    { label: "Branch", key: "branch" },
    { label: "Branch Payable", key: "branchPayable" },
    { label: "Commision Payable", key: "commisionPayable" },
    { label: "Pending Payable", key: "pendingBalance" },
  ];
  const csvFile = {
    filename: "Branch Payable Data",
    headers: header,
    data: wallet,
  };

  const handleSaveAllFilter = () => {
    GetData();
  };

  const filterBoxData = [
    {
      id: 1,
      label: "Select Date",
      setDate: setDateRange,
      type: "noDefaultDate",
    },
  ];

  const handleClearAllState = () => {
    setDateRange(null);
  };

  useEffect(() => {
    const handleDateChange = (dateRange) => {
      if (dateRange && Array.isArray(dateRange)) {
        const start = dateRange[0].$d;
        const end = dateRange[1].$d;
        setSelectedStartDate(start);
        setSelectedEndDate(end);
        GetData(start, end);
      } else {
        setSelectedStartDate(null);
        setSelectedEndDate(null);
        GetData(null, null);
      }
    };
    handleDateChange(dateRange);
  }, [dateRange]);

  const StateMentFunction = (row) => {
    setSelectedData([row]);
    setOpenDrawer(true);
  };

  const handleMultiDelete = (items) => {
    setSelectedItems(items);
  };

  const handleFiltersClick = () => {
    setFiltersVisible((prev) => !prev);
  };

  const activeFiltersCount = (() => {
    let count = 0;
    if (dateRange && Array.isArray(dateRange) && dateRange.length === 2)
      count += 1;
    return count;
  })();

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {/* Filter area toggled via Filters button */}
          {/* Table container below filter */}
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems="center"
                className="Master_Card_Sub_Container"
                spacing={2}
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Typography className="Master_Card_Tittle">
                    Branch Wallet
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  sx={{
                    display: "flex",
                    justifyContent: { md: "flex-end", sm: "flex-end" },
                  }}
                  gap={"8px"}
                >
                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{ alignItems: "center" }}
                  >
                    <Button
                      className="Master_Card_Filter_Button"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      startIcon={
                        <Badge
                          badgeContent={activeFiltersCount}
                          sx={{
                            "& .MuiBadge-badge": {
                              right: 5,
                              top: 3,
                              width: "14px",
                              height: "14px",
                              minWidth: "14px",
                              borderRadius: "50%",
                              fontSize: "8.91px",
                              fontWeight: "600",
                              backgroundColor: "#E50000",
                              color: "#fff",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                        >
                          <FilterListIcon sx={{ marginRight: "1.5px" }} />
                        </Badge>
                      }
                      onClick={() => setShowFilter((s) => !s)}
                      size="small"
                      variant="outlined"
                    >
                      Filters
                    </Button>
                    <Button
                      className="Master_Card_Filter_Button"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      startIcon={
                        <CloudDownloadOutlinedIcon
                          sx={{
                            color: "#344054",
                          }}
                        />
                      }
                      size="small"
                      variant="outlined"
                    >
                      <CSVLink
                        style={{ textDecoration: "none", color: "inherit" }}
                        {...csvFile}
                      >
                        Export
                      </CSVLink>
                    </Button>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section (toggled) */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                  />
                </Box>
              )}

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
              <Grid
                container
                alignItems={"center"}
                justifyContent={"flex-end"}
                margin={1}
              >
                <Grid item xs={12} sm={4} md={3.1}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    onChange={(e) => {
                      onSearch(e);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search in Access"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={visibleRows}
                columns={headCells}
                handleMultiDelete={handleMultiDelete}
                loading={openLoader}
              />
            </Grid>
          </Box>
        </Box>
      </div>

      <Drawer
        open={openDrawer}
        sx={{
          zIndex: 100,
        }}
        anchor="right"
        PaperProps={{
          sx: { width: { xs: "100%", sm: "100%" } },
        }}
      >
        {openDrawer ? (
          <ManageBranchWallet
            selectedData={selectedData}
            setOpenDrawer={setOpenDrawer}
          />
        ) : null}
      </Drawer>
    </>
  );
};
export default BranchWallet;
